export const parametersPerCompanyNames = {
  '1': {
    name: 'Empresa'
  },
  '2': {
    name: 'Geral'
  },
  '3': {
    name: 'Nota fiscal Serviço'
  },
  '4': {
    name: 'Nota fiscal outros'
  },
  '5': {
    name: 'Impressos',
    tab0: {
      '1': 'Mini Impressora',
      '2': 'Venda',
      '3': 'Conf. venda',
      '4': 'Orçamento',
      '5': 'Compra',
      '6': 'Vale Troca',
      '7': 'Sangria/Suprimento',
      '8': 'Caixa',
      '9': 'Separação',
      '10': 'Ajuste/Movimento',
      '11': 'Duplicata',
      '12': 'Entrega',
      '13': 'Estoque',
      '14': 'Fornecedor',
      '15': 'Encomenda',
      '16': 'Produção',
      '17': 'Autenticação',
      '18': 'Despacho',
      '19': 'Documento Auxiliar',
      '20': 'Cobrança Eletrônica',
      '21': 'Remessa/Transferência',
      '22': 'Outros',
      '23': 'Carnê',
      '24': 'Recibo',
      '25': 'Lista Escolar'
    }
  },
  '6': {
    name: 'NF-e'
  },
  '7': {
    name: 'NFP'
  },
  '8': {
    name: 'NFc-e'
  },
  '9': {
    name: 'Certificado digital'
  },
  '10': {
    name: 'Sat'
  },
  '11': {
    name: 'Tipos de pedido padrão'
  },
  '12': {
    name: 'MDF-e'
  },
  'G': {
    name: 'Futura Gourmet',
    tab0: {
      '14': 'Cozinha',
      '15': 'Delivery',
    }
  },
  'OS': {
    name: 'Futura OS',
    tab0: {
      '1': 'Ordem de serviço',
      '2': 'Adicional'
    }
  }
}